"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringDateTime = exports.isPresent = void 0;
const zod_1 = require("zod");
const isPresent = (value) => value !== null && value !== undefined && value !== "";
exports.isPresent = isPresent;
exports.stringDateTime = zod_1.z.iso.datetime({ offset: true }).nullish();
